import { render, staticRenderFns } from "./PartnerAPIsList.vue?vue&type=template&id=e87b65c0&scoped=true"
import script from "./PartnerAPIsList.vue?vue&type=script&lang=js"
export * from "./PartnerAPIsList.vue?vue&type=script&lang=js"
import style0 from "./PartnerAPIsList.vue?vue&type=style&index=0&id=e87b65c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87b65c0",
  null
  
)

export default component.exports